import axios from "axios";
import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Input,
  MenuItem,
  Select,
  TextareaAutosize,
  TextField,
} from "@mui/material";
import { GMB } from "../../../services/gmbApiConfig";
import { useSelector } from "react-redux";
import {
  selectAccountId,
  selectLocationId,
} from "../../../Store/Gmb/gmbStoreSlice";
import { toast } from "react-toastify";


export const isMoreDomainUrl =(url)=>{
    return  url?.split("//")?.[1]?.split(".")?.[0] ==="moreretail"
 }
const AddOfferToPost = ({
  onLinkTextChange,
  onVoucherCodeTextChange,
  onTermAndConditionsTextChange,
}) => {

  const [linkUrl, setLinkUrl] = useState("");
  const [vocherCode, setVocherCode] = useState("");
  const [termAndConditions, setTermAndConditions] = useState("");

  return (
    <>
      <TextField
        id="outlined-basic"
        label="Voucher Code (optional)"
        sx={{
          width: "100%",
        }}
        variant="outlined"
        value={vocherCode}
        onChange={(e) => {
          setVocherCode(e.target.value);
          onVoucherCodeTextChange(e.target.value);
        }}
      />
      <TextField
        id="outlined-basic"
        label="Link to redeem offer (optional)"
        sx={{
          width: "100%",
        }}
        variant="outlined"
        value={linkUrl}
        onChange={(e) => {
          setLinkUrl(e.target.value);
          onLinkTextChange(e.target.value);
        }}
      />
      <TextField
        id="outlined-basic"
        label="Terms and Conditions (optional)"
        sx={{
          width: "100%",
        }}
        variant="outlined"
        value={termAndConditions}
        onChange={(e) => {
          setTermAndConditions(e.target.value);
          onTermAndConditionsTextChange(e.target.value);
        }}
      />
    </>
  );
};

export default AddOfferToPost;
